module.exports = __webpack_public_path__ + "ida_logo_redesign_designawards_graphic_design.jpg?a3e364cd71ae7ec4a52d0393000bf9e3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/ida/ida_logo_redesign_designawards_graphic_design.jpg
// module id = 70
// module chunks = 0